import { Step } from 'prosemirror-transform';
import memoizeOne from 'memoize-one';
import { handleInit, handleConnection, handlePresence, handleTelePointer, applyRemoteData, } from '../actions';
import { pluginKey } from '../plugin-key';
import { unsubscribeAllEvents } from './unsubscribe';
var initCollab = function (collabEditProvider, view) {
    collabEditProvider.initialize(function () { return view.state; }, function (json) { return Step.fromJSON(view.state.schema, json); });
};
var initCollabMemo = memoizeOne(initCollab);
export var initialize = function (_a) {
    var options = _a.options, providerFactory = _a.providerFactory, view = _a.view;
    return function (provider) {
        var pluginState = pluginKey.getState(view.state);
        if (pluginState.isReady) {
            unsubscribeAllEvents(provider);
        }
        provider
            .on('init', function (data) {
            view.dispatch(view.state.tr.setMeta('collabInitialised', true));
            handleInit(data, view, options, providerFactory);
        })
            .on('connected', function (data) { return handleConnection(data, view); })
            .on('data', function (data) { return applyRemoteData(data, view, options); })
            .on('presence', function (data) { return handlePresence(data, view); })
            .on('telepointer', function (data) { return handleTelePointer(data, view); })
            .on('local-steps', function (data) {
            var steps = data.steps;
            var state = view.state;
            var tr = state.tr;
            steps.forEach(function (step) { return tr.step(step); });
            view.dispatch(tr);
        })
            .on('error', function (error) {
            // TODO: Handle errors property (ED-2580)
            // eslint-disable-next-line no-console
            console.log('error: ', error);
        });
        // Initialize provider
        /**
         * We only want to initialise once, if we reload/reconfigure this plugin
         * We dont want to re-init collab, it would break existing sessions
         */
        initCollabMemo(provider, view);
    };
};
//# sourceMappingURL=initialize.js.map